/* Copyright(c) 2024 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/*@author :Chaitanya Shende
 *@fileName :addUserQA.js
 *Desc: 5043-Add User
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import Footer from "../layouts/footer";
import Navigation from "../layouts/navPage";
import { Tooltip, Icon, Table, Radio } from "antd"; //Anshul-5726: added Radio
import { css } from "emotion"; //Sandeep-task-3447-added css file
import "./addUserAgency.css"; //Sandeep-task-3447-added css file
import { fetch_custom as fetch } from "../../configration/fetch_default_headers"; // karan-task-3723-vapt header and query params
const Swal = require("sweetalert2");
const tableCSS = css({
  backgroundColor: "white",
  fontFamily: "sans-serif",
  fontSize: "20px",
  borderStyle: "bold",
  margin: "10px", //Anshul-5726: added margin for table
  boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px", //Anshul-5780
  "& thead > tr > th": {
    backgroundColor: "#144999", //rutuja task -4524 changed background color
    color: "white",
    fontWeight: "500",
  },
  "& thead > tr": {
    borderWidth: "2px",
    borderStyle: "solid",
  },
}); //Sandeep-task-3447-added Tablecss file

class AddUserDIQA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputClass11: "btn add-button",
      fields: {},
      errors: "",
      loader2: "",
      userDomain: "",
      userOrgID: "", // Kiran Dhainje 5848 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
      selectedUserDomain: "@machbizz.com", //Sanjana-3192-For default domain in select dropdown in case user login with "machbizz.com"
      tableSearchText: "",//Rutuja-5462-added to store value for search
      userDetailsSearch: [],//Rutuja-5462-added search data array
      filterStatus: "activeUsers", //Anshul-5726: for storing active or deactivated radio button value
      activatedUsersCheckboxArray: [], //Anshul-5726: added to store the active users
      deactivatedUsersCheckboxArray: [], //Anshul-5726: added to store the deactivated users
      disableSaveButton: true,//Anshul-5726: added to enable/disable save button
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitUser = this.submitUser.bind(this);
    this.dropDownChange = this.dropDownChange.bind(this); //Sanjana-3192-handleChange function for dropdown in case user login with "machbizz.com"
    this.backButtonHandleChange = this.backButtonHandleChange.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);//Rutuja-5462-added search function binding 

  } // end of constructor

  backButtonHandleChange(e) {
    e.preventDefault();
    //Priyanka-5465-Changed page name
    this.props.history.push("/qualityDashboard");
  }
  componentDidMount() {
    const { user } = this.props.auth;
    const userOrgID = user.id; //Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel
    var userName = user.name;
    userName = userName.split("@");
    var userName1 = "@" + userName[1];

    /* @author Sandeep Dhawale
     * @param  Description get user details
     * @return Description get user details
     */

    this.setState({ loader2: "loader_report1", userOrgID: userOrgID });//Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel

    fetch("/users/getUserListDIQA", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    }) // karan-task-3723-vapt header and query params
      .then((res) => res.json())
      .then((getUserListDIQA) => {
        // Filter to show only DIQAs with matching orgID
        // Kiran Dhainje 5848 DC-Display Campaigns, Leads and DIQA users for Email Marketing Channel
        const filteredByOrgID = getUserListDIQA.filter(
          (user) => user.orgID === userOrgID
        );
        this.setState({ getUserListDIQA: filteredByOrgID, loader2: "" });
      })
      .catch(function (err) {
        console.log(err);
      });
    //Sanjana-3192-condition to display single/multiple domain suggestion in case user login with "machbizz.com"
    if (userName[1] === "machbizz.com" || userName[1] === "machbizz.co.in") {
      const selectAfter = (
        <select
          onChange={this.dropDownChange}
          style={{ backgroundColor: "#fafafa", border: "0px solid #d9d9d9" }}
        >
          <option selected name=".machbizz.com" value="@machbizz.com">
            @machbizz.com
          </option>
          <option name=".machbizz.co.in" value="@machbizz.co.in">
            @machbizz.co.in
          </option>
        </select>
      );
      this.setState({ userDomain: selectAfter });
    } else {
      this.setState({ userDomain: userName1 });
    }
  } //end of componentDidMount

  //Sanjana-3192-handleChange function for dropdown in case user login with "machbizz.com"
  dropDownChange(e) {
    // const { name, value } = e.target; // Nilesh-2833-Removing console warnings
    const { value } = e.target;
    this.setState({ selectedUserDomain: value });
  }
  validateForm() {
    // alert("inside validate form");
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;
    let spanDisplay = "none";
    let requiredFeildValidate = true; //Nilesh-2833-Removing console warnings
    let userNameValidate = true; //Nilesh-2833-Removing console warnings
    let firstNameValidate = true; //Nilesh-2833-Removing console warnings
    let lastNameValidate = true; //Nilesh-2833-Removing console warnings
    let roleValidate = true; //Nilesh-2833-Removing console warnings
    // Only append a domain if the entered userName does not already contain '@'.
    //Kiran Dhainje 5863 Ref(5847)-DT-Add User-Showing User Already Exist error for new user
    // Guard against `userDomain` being a JSX element; prefer `selectedUserDomain` when it's a string.
    const entered = (fields["userName"] || "").toString();
    if (entered.indexOf("@") === -1) {
      let domainToAppend = "";
      if (
        this.state.selectedUserDomain &&
        typeof this.state.selectedUserDomain === "string"
      ) {
        domainToAppend = this.state.selectedUserDomain;
      } else if (typeof this.state.userDomain === "string") {
        domainToAppend = this.state.userDomain;
      }

      if (domainToAppend) {
        fields["userName"] = entered + domainToAppend;
      } else {
        fields["userName"] = entered;
      }
    } else {
      // already contains domain, keep as-is
      fields["userName"] = entered;
    }
    this.setState({ fields });

    if (
      !fields["userName"] &&
      !fields["role"] &&
      !fields["firstName"] &&
      !fields["lastName"]
    ) {
      requiredFeildValidate = false;
      errors["commonError"] = <li>Please fill below required fields</li>;
      this.setState({ errors: errors });
    } else {
      if (
        //Nilesh-2833-Removing console warnings
        this.state.userName === "" ||
        this.state.userName == null ||
        this.state.userName === undefined
      ) {
        userNameValidate = false;
        //errors["userName"] = <li>Please enter user name</li>;
        errors["userName"] = <li>Please enter user name</li>;
        this.setState({ errors: errors });
      } else {
        //shivani - 3599 - changed RegEx as per validation requirement for hyphen .
        //sunita-task-3782-below regex accept only business domains.
        //Sandeep-task-3893-Production issue-Email format issue--All roles
        var pattern = new RegExp(
          // eslint-disable-next-line no-useless-escape
          /^\s*$|^[\.a-zA-Z0-9_%+]+[\w-]+[a-zA-Z0-9_%+]+(\.[a-zA-Z0-9]+)*@(?!gmail.com)(?!gmail.co.in)(?!yahoo.com)(?!yahoo.co.in)(?!facebook.com)(?!facebook.co.in)[a-zA-Z0-9]+[\w-]+[a-zA-Z0-9]+\.([a-zA-Z]{3,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/
        );
       // 5778-Kiran Dhainje -commented This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting
      //   if (this.state.userName.match(pattern)) {
      //     // mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
      //     userNameValidate = true;
      //   } else {
      //     userNameValidate = false;
      //     errors["userName"] = <li>Please enter valid user name</li>;
      //     this.setState({ errors: errors });
      //   } // mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
      // }
      // Added the confition for this 5778-Kiran- This Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting

       if (!this.state.userName || /^\s*$/.test(this.state.userName)) {
            userNameValidate = false;
            errors["userName"] = <li>User name cannot be blank or spaces</li>;
          this.setState({ errors: errors });
        } else if (this.state.userName.match(pattern)) {
               // existing email regex check
                userNameValidate = true;
               } else {
               userNameValidate = false;
               errors["userName"] = <li>Please enter valid user name</li>;
                      this.setState({ errors: errors });
                   }
      }

      if (
        //Nilesh-2833-Removing console warnings
        this.state.firstName === "" ||
        this.state.firstName == null ||
        this.state.firstName === undefined
      ) {
        firstNameValidate = false;
        errors["firstName"] = <li>Please enter first name</li>;
        this.setState({ errors: errors });
      } else {
        let pattern = new RegExp(/^[a-zA-Z]+$/); // Nilesh-2833-Removing console warnings
        if (!pattern.test(fields["firstName"])) {
          userNameValidate = false;
          errors["firstName"] = <li>please enter valid first name</li>;
          this.setState({ errors: errors });
        } else {
          errors["firstName"] = "";
          this.setState({ errors: errors });
        }
      }
      if (
        //Nilesh-2833-Removing console warnings
        this.state.lastName === "" ||
        this.state.lastName == null ||
        this.state.lastName === undefined
      ) {
        lastNameValidate = false;
        errors["lastName"] = <li>Please enter last name</li>;
        this.setState({ errors: errors });
      } else {
        let pattern = new RegExp(/^[a-zA-Z]+$/); // Nilesh-2833-Removing console warnings
        if (!pattern.test(fields["lastName"])) {
          userNameValidate = false;
          errors["lastName"] = <li>please enter valid last name</li>;
          this.setState({ errors: errors });
        } else {
          errors["lastName"] = "";
          this.setState({ errors: errors });
        }
      }
      if (
        //Nilesh-2833-Removing console warnings
        this.state.role === "" ||
        this.state.role == null ||
        this.state.role === undefined
      ) {
        roleValidate = false;
        errors["role"] = <li>Please enter role</li>;
        this.setState({ errors: errors });
      } else {
        errors["role"] = "";
        this.setState({ errors: errors });
      }
    }

    if (
      requiredFeildValidate === false ||
      userNameValidate === false ||
      firstNameValidate === false ||
      lastNameValidate === false ||
      roleValidate === false
    ) {
      formIsValid = false;
      this.setState({
        errors: errors,
        alertBorder: "1px solid red",
        alertWidth: "1000px",
        alertAlign: "center",
        alertDisplay: "block",
        spanSpaceDisplay: spanDisplay,
      });
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      requiredFeildValidate === true || // mufiz Task-3984 Settings - Add User - Username should accept EmailID as per tooltip
      userNameValidate === true ||
      firstNameValidate === true ||
      lastNameValidate === true ||
      roleValidate === true
    ) {
      formIsValid = true;
      // alert("success");
    }
    return formIsValid;
  }

  // handleChange(e) {
  //   let fields = this.state;
  //   fields[e.target.name] = e.target.value;
  //   this.setState({ fields });
  // }

  // Anshul-5726: updated handle change to enable/disable save button
  handleChange(e) {
    // Anshul-5781: updated state
    let fields = this.state.fields;
    const { name, value } = e.target;
     fields[name] = value;
const { userName, firstName, lastName, role } = fields;
  this.setState(
    { 
      fields,
      [name]: value }, 
    () => {
    //  const { userName, firstName, lastName, role } = this.state;
      const allFilled = userName && firstName && lastName && role && role !== "None Selected";

      this.setState({ disableSaveButton: !allFilled });
    }
  );
}

  //Supriya: Submit User
    //Kiran Dhainje 5847 commented old submit user function
  //  submitUser(e) {
  //   //Sanjana-3192-condition added to generate final data  when user in case user login with "machbizz.com"/ with "apssmedia.com"
  //   let data;

  //   if (this.state.userDomain) {
  //     data = {
  //       userName: this.state.userName,
  //       firstName: this.state.firstName,
  //       lastName: this.state.lastName,
  //       role: this.state.role,
  //     }; // karan-task-3723-vapt header and query params
  //   } else {
  //     data = {
  //       userName: this.state.userName + this.state.selectedUserDomain,
  //       firstName: this.state.firstName,
  //       lastName: this.state.lastName,
  //       role: this.state.role,
  //     }; // karan-task-3723-vapt header and query params
  //   }
	
  submitUser(e) {
    //Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel
    // Build final username robustly (trim, respect explicit @, avoid double-appending domains)
    const rawUserName = (((this.state.fields && this.state.fields.userName) || this.state.userName) || "").toString().trim();
    let finalUserName = rawUserName;
    //Kiran Dhainje 5863 Ref(5847)-DT-Add User-Showing User Already Exist error for new user commented ths
    // If user already entered an email address, do not append domain
    if (!finalUserName.includes("@")) {
      const sel = this.state.selectedUserDomain;
      const ud = this.state.userDomain;

      if (sel && typeof sel === "string" && sel !== "null" && sel !== "") {
        if (!finalUserName.endsWith(sel)) finalUserName = finalUserName + sel;
      } else if (ud && typeof ud === "string" && ud !== "null" && ud !== "") {
        if (!finalUserName.endsWith(ud)) finalUserName = finalUserName + ud;
      }
    }

    // Normalize email: extract base email to handle comparison across domains/roles
    // This ensures we detect same email with different roles as duplicates
       //Kiran Dhainje 5863 Ref(5847)-DT-Add User-Showing User Already Exist error for new user
    const normalizeEmail = (email) => {
      const emailStr = (email || "").toString().trim();
      // Return lowercase for comparison (strip whitespace, normalize case)
      return emailStr.toLowerCase();
    };

    const normalizedEmail = normalizeEmail(finalUserName);

    const data = {
      userName: finalUserName,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      role: this.state.role,
    }; // karan-task-3723-vapt header and query params

    if (this.validateForm() === false) {
      return;
    } else {
      let errors = {};
      fetch("/users/addUserDetails", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((userDetails) => {
          // Kiran Dhainje 5863 Ref(5847)-DT-Add User-Showing User Already Exist error for new user
          // Normalize all existing user emails for comparison to detect duplicates across roles
          const matches = (userDetails || []).filter((u) => {
            if (!u || !u.userName) return false;
            const normalizedExisting = normalizeEmail(u.userName);
            return normalizedExisting === normalizedEmail;
          });

          const userOrgID = this.state.userOrgID;

          // Show "User Already Exists" if same email exists in same org (any role)
          // This prevents duplicate entries and properly handles role separation
             //Kiran Dhainje 5863 Ref(5847)-DT-Add User-Showing User Already Exist error for new user
          const conflict = matches.some((u) => {
            const uOrg = u.orgID !== undefined ? u.orgID : u.orgId;
            return String(uOrg) === String(userOrgID);   //Kiran Dhainje 5863 Ref(5847)-DT-Add User-Showing User Already Exist error for new user
          });

          if (conflict) {
            errors["sameUser"] = <li>User Already Exists</li>;
            this.setState({ errors: errors });
          } else {
            // Proceed to create user. Include orgID so backend can make correct decision too.
            const createData = Object.assign({}, data, { orgID: userOrgID });
            fetch("/users/addUser", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(createData),
            })
              .then(function (response) {
                if (response.status >= 400) {
                  throw new Error("Bad response from server");
                }
                return response.json();
              })
              .then(function (response) {
                // success message with response
                if (response.success === true) {
                  //Nilesh-2833-Removing console warnings
                  Swal.fire({
                    text: "User Added Successfully",
                    type: "success",
                    confirmButtonText: "Ok",
                    allowOutsideClick: false,
                    preConfirm: () => {
                      window.location.reload(); //sunita-task-3764-added code for refreshing the page.
                    },
                  });
                }
              })
              .catch(function (err) {
                console.error("Error creating user:", err);
              });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  }
  
  //kiran-4596-function for route call
  // changeUserStatusInactive(e, record) {
  //   // const {name, value } = e.target; // Nilesh-2833-Removing console warnings
  //   var orgID = record.userID;
  //   let data = {
  //     orgID: orgID,
  //   };
  //   fetch("/users/setUserStatusInactive", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((response) => {
  //       if (response.success === true) {
  //         Swal.fire({
  //           text: "User Deactivated",
  //           type: "success",
  //           confirmButtonText: "Ok",
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           },
  //         });
  //       }
  //       this.setState({ isDisabled: true });
  //     });
  // }

  // Anshul-5726: updated above code to send array of user instead of single

    changeUserStatusInactive() {
    const { activatedUsersCheckboxArray } = this.state;

    if (
      !Array.isArray(activatedUsersCheckboxArray) ||
      activatedUsersCheckboxArray.length === 0
    ) {
      console.error("No active users selected for deactivation.");
      return;
    }

    const data = activatedUsersCheckboxArray.map((userID) => ({ userID }));

    fetch("/users/setUserStatusInactive", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.success === true) {
          Swal.fire({
            text: "User Deactivated",
            type: "success",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
            preConfirm: () => {
              window.location.reload();
            },
          });
        } else {
          Swal.fire({
            text: "Some users could not be deactivated.",
            type: "error",
            confirmButtonText: "Ok",
            allowOutsideClick: false,
          });
        }

        this.setState({ isDisabled: true });
      });
  }

  //Chaitanya-5043-function for Active status route call
  // changeUserStatusActive(e, record) {
  //   var orgID = record.userID;
  //   //Priyanka-5438-Passing role
	// 	var role = record.role;
	// 	let data = {
	// 	  orgID: orgID,
	// 	  role:role,
  //     userName : record.userName  //Priyanka-5468-Passing selected username to BE
	// 	};
  //   fetch("/users/setUserStatusActiveDIQA", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((response) => {
  //       if (response.success === true) {
  //         Swal.fire({
  //           text: "User Activated",
  //           type: "success",
  //           confirmButtonText: "Ok",
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           },
  //         });
  //       }
  //       else{
  //         //Priyanka-5468-Showing error message
  //         Swal.fire({
  //           text: "User Already exists",
  //           type: "error",
  //           confirmButtonText: "Ok",
  //           allowOutsideClick: false,
  //           preConfirm: () => {
  //             window.location.reload();
  //           },
  //         });
  //       }
  //       this.setState({ isDisabled: true });
  //     });
  // }

  // Anshul-5726: updated the above code to send multiple users instead of sigle
  //Kiran Dhainje 5847 DT -Display Campaigns, Leads and DIQA users for Email Marketing Channel
  changeUserStatusActive() {
      const { deactivatedUsersCheckboxArray,orgID } = this.state;
  
      if (
        !Array.isArray(deactivatedUsersCheckboxArray) ||
        deactivatedUsersCheckboxArray.length === 0
      ) {
        console.error("No active users selected for deactivation.");
        return;
      }
      //Kiran Dhainje 5847 DT -Display Campaigns, Leads and DIQA users for Email Marketing Channel
      const data = deactivatedUsersCheckboxArray.map((u) => ({ userID: u.userID,orgID }));
      fetch("/users/setUserStatusActiveDIQA", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.success === true) {
            Swal.fire({
              text: "User Activated",
              type: "success",
              confirmButtonText: "Ok",
              allowOutsideClick: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          } else {
            Swal.fire({
              text: "Some users could not be Activated.",
              type: "error",
              confirmButtonText: "Ok",
              allowOutsideClick: false,
              preConfirm: () => {
                window.location.reload();
              },
            });
          }
          this.setState({ isDisabled: true });
        })
        .catch((error) => {
          console.error("Error in deactivation request:", error);
        });
    }

  //Rutuja-5462-added handleChangeSearch to Search user by firstName,lastName email & role
  handleChangeSearch(e) {
    e.preventDefault();

    let currentList = [];
    // Variable to hold the filtered list before putting into state
    let newList = [];
    let filterData = e.target.value;

    this.setState({filterData})
    // If the search bar isn't empty
    if (e.target.value.toString() === "") { //kiran-2836-Removing console warnings
      newList = this.state.getUserListDIQA;
    } else {
      // Assign the original list to currentList
      currentList = this.state.getUserListDIQA
      newList = currentList.filter((item) => {
        let obj={};//Somnath Task-3972, Add required comumn in search fields
        obj[`firstName`]=item.firstName;
        obj[`lastName`]=item.lastName;
        obj[`email`]=item.userName;
        obj[`role`]=item.role;
        // change current item to lowercase
        const lc = obj;
        //const lc = item.toLowerCase();
        // change search term to lowercase
        const filter = e.target.value.toLowerCase();
        var data = Object.values(lc);
        var dataFinal = data.toString();
        dataFinal = dataFinal.replace(",", " ");
        var dataToLower = dataFinal.toLowerCase();
        return dataToLower.includes(filter);
      });
    }

    // Set the filtered state based on what our rules added to newList
    this.setState({
      userDetailsSearch: [...newList],
      tableSearchText: filterData,
    });
  }


  // Anshul-5726: handle checkbox column

  handleCheckboxChange = (e, record) => {
  const {
    filterStatus,
    activatedUsersCheckboxArray,
    deactivatedUsersCheckboxArray,
  } = this.state;

  const isChecked = e.target.checked;
  const userData = {
    userID: record.userID,
    role: record.role,
    userName: record.userName 
  };

  let arrayToUpdate =
    filterStatus === "activeUsers"
      ? activatedUsersCheckboxArray
      : deactivatedUsersCheckboxArray;

  const updatedArray = isChecked
    ? [...arrayToUpdate, userData] 
    : arrayToUpdate.filter((u) => u.userID !== record.userID); 

  const newState =
    filterStatus === "activeUsers"
      ? { activatedUsersCheckboxArray: updatedArray }
      : { deactivatedUsersCheckboxArray: updatedArray };

  this.setState(newState);
};

  render() {

    // Anshul-5726: filtere the table data according to status activate/deactivate
    const { getUserListDIQA, userDetailsSearch, tableSearchText, filterStatus } =
      this.state;
let filteredData = tableSearchText === "" ? getUserListDIQA : userDetailsSearch;

    filteredData = filteredData?.filter((user) => {
      const isActive =
        user.status === "Y" || user.status === null || user.status === "";
      return filterStatus === "activeUsers" ? isActive : !isActive;
    });

    const asterisk = {
      color: "red",
    };
    //Sandeep-task-3447-added table to get user details
    const addUserAgency = [

      // Anshul-5726: Added checkbox column in table
        {
                title: "",
                dataIndex: "",
                key: "checkbox",
                width: 30,
                align: "center",
                render: (text, record) => {
                  const isUserAlreadyActive = this.state.getUserListDIQA.some(
                    (u) =>
                      u.userName === record.userName &&
                      u.role === record.role &&
                      (u.status === "Y" || u.status === null || u.status === "")
                  );
        
                  const isDeactivatedView =
                    this.state.filterStatus === "deactivatedUsers";
                  const shouldDisableCheckbox =
                    isUserAlreadyActive && isDeactivatedView;
        
                   const isChecked =
            this.state.filterStatus === "activeUsers"
              ? this.state.activatedUsersCheckboxArray.some(
                  (u) => u.userID === record.userID
                )
              : this.state.deactivatedUsersCheckboxArray.some(
                  (u) => u.userID === record.userID
                );
        
                  const checkbox = (
                    <input
                      type="checkbox"
                      checked={isChecked}
                      disabled={shouldDisableCheckbox}
                      onChange={(e) =>
                        !shouldDisableCheckbox && this.handleCheckboxChange(e, record)
                      }
                      style={{
                        width: "20px",
                        height: "20px",
                        cursor: shouldDisableCheckbox ? "not-allowed" : "pointer",
                        accentColor: "#0A61AD",
                      }}
                    />
                  );
        
                  return (
                    <div>
                      {shouldDisableCheckbox ? (
                        <Tooltip title="User is already active with this role">
                          <span>{checkbox}</span>
                        </Tooltip>
                      ) : (
                        checkbox
                      )}
                    </div>
                  );
                },
              }, //Anshul-5726: end checkbox
      {
        title: "ID",
        dataIndex: "ID",
        key: "ID",
        width: 40,
        align: "Center",
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.userID}</span>
          </div>
        ),
      },
      {
        title: "First Name",
        dataIndex: "firstName",
        key: "firstName",
        width: 90,
        align: "Center",
        render: (text, record) => (
          <div>
            <div style={{ fontSize: "14px", width: "110px" }}>
              {record.firstName}
            </div>
          </div>
        ),
      },
      {
        title: "Last Name",
        dataIndex: "lastName",
        key: "lastName",
        width: 90,
        align: "Center",
        render: (text, record) => (
          <div>
            <div class="word-wrap" style={{ fontSize: "14px" }}>
              {record.lastName}
            </div>
          </div>
        ),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: 150,
        align: "Center",
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.userName}</span>
          </div>
        ),
      },
      {
        title: "Role",
        dataIndex: "role",
        key: "role",
        width: 60,
        align: "Center",
        render: (text, record) => (
          <div>
            <span style={{ fontSize: "14px" }}>{record.role}</span>
          </div>
        ),
      },
      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        width: 40,
        align: "center",
        render: (text, record) => (
          <div>
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
                color: record.status === "N" ? "red" : "green",
              }}
            >
              {record.status === "N" ? "Deactivated" : "Active"}
            </span>
          </div>
        ),
      },

      // Anshul-5726: removed action column from table
      // {
      //   title: "Action",
      //   dataIndex: "Action",
      //   key: "Action",
      //   width: 40,
      //   align: "Center",
      //   render: (text, record) => (
      //     <div>
      //       {/* Aman-4961-added record.status === "" to AC user with empty user status can Deactive user */}
      //       {record.status === "Y" ||
      //       record.status === null ||
      //       record.status === "" ? (
      //         <button
      //           style={{ padding: "7px 7px" }}
      //           className={this.state.inputClass11}
      //           onClick={(e) => this.changeUserStatusInactive(e, record)}
      //           // disabled={this.state.isDisabled}
      //           type="submit"
      //         >
      //           Deactive{" "}
      //         </button>
      //       ) : (
      //         <button
      //           style={{ padding: "7px 7px" }}
      //           className={this.state.inputClass11}
      //           onClick={(e) => this.changeUserStatusActive(e, record)}
      //           //disabled='disabled'
      //           type="submit"
      //         >
      //           Activate{" "}
      //         </button>
      //       )}
      //     </div>
      //   ),
      // },
    ];
    return (
      <div>
        <Navigation />
        <div class="container-fluid" style={{ paddingTop: "108px" }}>
          <div class="row">
            <div class="col-lg-4" id="AddUser" style={{ paddingLeft: "20px" }}>
              <a
                style={{ color: "#056eb8" }}
                href="#/"
                onClick={this.backButtonHandleChange}
              >
                <FaArrowAltCircleLeft
                  size={32}
                  style={{ float: "left" }}
                  title="Back to Dashboard"
                />
              </a>
            </div>
          </div>
          <h2
            align="center"
            id="labelDI"
            class="addUsr"
            style={{ marginTop: "-31px" }}
          >
            {/* Anshul-5726: changed page title */}
            {/* Anshul-5780: changed page title */}
            Add/Manage Users
          </h2>
          {/* Anshul-5726: updated code to show input fields in one row */} 
          <div
            class="card-body"
            className="cardBodyClass pubcardBodyClass"
            style={{
              margin: "10px",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow: "grey 1px 1px 6px 0px", //mufiz-task-3975 styling a box
            }}
          >
            {/* <legend className="legend labelsubheading">User Details</legend> */}
            {/* //shivani-3284-passed ID for DI label consistency */}
            {/*Anshul-5726: commented below div */}
            {/* <div class="col-12" style={{ textAlign: "center" }}></div> 
              
                          <div style={{ fontSize: "14px", color: "red" }}>
                            {this.state.errors.commonError}
                          </div>
                          <div
                            className="errorMsg"
                            style={{ fontSize: "14px", color: "red" }}
                          >
                            {this.state.errors.userName}
                            {this.state.errors.role}
                            {this.state.errors.firstName}
                            {this.state.errors.lastName}
                            {this.state.errors.sameUser}
                          </div> */}
            {/* <div class="row">  */}{" "}
            {/* anshul-5726: added new div to show fields in one row */}
            <div
              className="user-input-container"
              style={{
                display: "flex",
                gap: "75px",
                alignItems: "flex-end",
                flexWrap: "wrap",
              }}
            >
              {" "}
              {/* anshul-5726: added new div to combine all fields in one row */}
              {/* <div class="col-xs-12 col-sm-12 col-md-2 col-lg-4" >
                       <label id="label">User Name <span style={asterisk}>*&nbsp; 
                       <Tooltip title=" User name should be Valid Email Id.">
                       <Icon type="question-circle-o" />
                     </Tooltip></span></label>
                       <input
                       value={this.state.userName}
                       onChange={this.handleChange}
                       type="text"
                       id="userName"
                       className="form-control"
                       name="userName"
                       style={{ width: "60%", height: "60%" }}
                       required />
                     </div> */}
              {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"> */}{" "}
              {/* anshul-5726 : commented above div and added new div */}
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                <label id="label">
                  User Name{" "}
                  <span style={asterisk}>
                    *&nbsp;
                    <Tooltip title=" User name should be Valid Email Id.">
                      <Icon
                        type="question-circle-o"
                        className="iconbackground"
                      />
                      {/*sunita-task-3818-added classname as per requirement for removing white patches */}
                    </Tooltip>
                  </span>
                </label>
                {/* <br /> */}
                {/* Anshul-5726: removed react Input and added HTML input */}
                {/* Kiran Dhainje-5778:Added the condtion for not accepect the space. Prod Issue-AC/PC/DC/ADV/AQA-Add User-Blank User Name accepting */}

                <input
                  // addonAfter={this.state.userDomain} //sunita-task-3782-commented this attribute as want to enable the domain field.
                  value={this.state.userName}
                  onChange={this.handleChange}
                  onKeyDown={(e)=>{
                    if(e.key===" ")e.preventDefault();
                  }} 
                  type="text"
                  id="dcUserName" 
                  className="form-control"
                  name="userName"
                  style={{
                    width: "100%",
                    height: "60%",
                    borderRadius: "10px",
                    boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                  }} // Anshul-5726: changed width from 60% to 100%, removed padding
                  required
                ></input>
              </div>
              {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 Proleinputbox"> */}
              {/* Anshul-5726: comment above div and added new with flex 1 */}
              {/* </div> */}{" "}
              {/* anshul-5726: commented div to show fields in one row */}
              {/* <br /> */}
              {/* end of 1st row */}
              {/* <div class="row"> */}{" "}
              {/* anshul-5726: commented div to show fields in one row */}
              {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"> */}
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                <label id="label">
                  First Name <span style={asterisk}>*</span>
                </label>
                <input
                  value={this.state.firstName}
                  onChange={this.handleChange}
                  type="text"
                  id="firstName"
                  className="form-control"
                  name="firstName"
                  style={{
                    width: "100%",
                    height: "60%",
                    borderRadius: "10px",
                    boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                  }} // Anshul-5726: Set width to 100%, removed padding
                  required
                />
              </div>
              {/* <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 Proleinputbox"> */}
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                <label id="label">
                  Last Name <span style={asterisk}>*</span>
                </label>
                <input
                  value={this.state.lastName}
                  onChange={this.handleChange}
                  type="text"
                  id="lastName"
                  className="form-control"
                  name="lastName"
                  style={{
                    width: "100%",
                    height: "60%",
                    borderRadius: "10px",
                    boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                  }} // Anshul-5726: Set width to 100%, removed padding
                  required
                />
              </div>
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                {/*sunita-task-3782-added classname as per requirement */}
                <label id="label">
                  Role <span style={asterisk}>*</span>
                </label>
                <select
                  value={this.state.role}
                  onChange={this.handleChange}
                  type="text"
                  id="role"
                  className="form-control"
                  name="role"
                   style={{
                         width: "100%",
                         height: "60%",
                         borderRadius: "10px",
                         boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                       }}
                  required
                >
                  <option value="None Selected" disabled selected>
                    None Selected
                    {/*// Kiran Dhainje 5847 DT-Display Campaigns, Leads and DIQA users for Email Marketing Channel */}
                  </option>
                  {/* Rutuja 5167 changed DIQA to LNQA */}
                  {this.props.auth.user.role === "LC" ? (
                    <>
                    <option value="LC">LNQA Commercial</option>
                    <option value="LNQA">LNQA</option>
                    </>
                    ) : (
                    <>
                    <option value="LT">LNQA TeleCommercial</option>
                    <option value="LNQA">LNQA</option>
                    </>
                    )}
                </select>
              </div>
              <div style={{ flex: 1 }}>
                {" "}
                {/*Anshul-5726:  Updated to col-md-2 for 5 equal columns */}
                <Tooltip
                  title={
                    this.state.disableSaveButton
                      ? "All fields marked with * are mandatory"
                      : ""
                  }
                >
                  <span>
                    <button
                      style={{
                        width: "40%",
                        margin: "0px",
                        marginLeft: "50px",
                        borderRadius: "10px",
                        boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
                      }}
                      className="btn add-button buttonSave"
                      onClick={this.submitUser}
                      type="submit"
                      disabled={this.state.disableSaveButton}
                    >
                      {/* Anshul-5780: changed button label */}
                      Add
                    </button>
                  </span>
                </Tooltip>
              </div>
            </div>
            {/* </div> */}{" "}
            {/* anshul-5726: commented div to show fields in one row */}
            {/* end of 2nd row */}
            {/* <br /> */} {/* Anshul-5726:*/}
            {/* locale={this.state.loading1?locale:"No Data"} */}
            {/* pagination={{ pageSize: this.state.pageSize1 }} */}
            {/* Anshul-5721: added error message below input fields */}
            <div class="col-12" style={{ textAlign: "center" }}></div>
            <div style={{ fontSize: "14px", color: "red" }}>
              {this.state.errors.commonError}
            </div>
            <div
              className="errorMsg"
              style={{ fontSize: "14px", color: "red", marginTop: "10px" }}
            >
              {this.state.errors.userName}
              {this.state.errors.role}
              {this.state.errors.firstName}
              {this.state.errors.lastName}
              {this.state.errors.sameUser}
            </div>
          </div>
        </div>

        {/* end of card body */}

        {/* end of container-fluid */}
        {/* //Rutuja-5461-added input for serach*/}
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ width: "100%" }}
        >
          {/* Left: Radio buttons */}
          <div style={{ marginLeft: "15px", marginTop: "15px" }}>
            <Radio.Group
              onChange={(e) => this.setState({ filterStatus: e.target.value })}
              value={this.state.filterStatus}
            >
              <Radio value="activeUsers">Active Users</Radio>
              <Radio value="deactivatedUsers">Deactivated Users</Radio>
            </Radio.Group>
          </div>

          {/* Right: Search */}
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <Tooltip title="Find the user's by Email/First Name/Last Name or role.">
              <Icon
                type="question-circle-o"
                className="iconbackground"
                style={{ marginTop: "10px" }}
              />
            </Tooltip>
            <input
              type="text"
              id="search_agency_addUser"
              className="form-control search_agency_addUser"
              value={this.state.filterData}
              onChange={this.handleChangeSearch}
              placeholder="Search..."
              title="Search"
              style={{
                backgroundImage: "url(searchIcon.png)",
                backgroundPosition: "15px 6px",
                backgroundSize: "15px 15px",
                backgroundRepeat: "no-repeat",
                height: "20px",
                fontSize: "12px",
                borderRadius: "25px", //Anshul-5726: Increases the border radius
                border: "1px solid rgb(221, 221, 221)",
                padding: "16px 20px 16px 34px",
                margin: "15px",        // Anshul-5726: added margin for search input
                boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
              }}
            />
          </div>
        </div>

        <br />
        <div id={this.state.loader2} />
        <p>
          {this.state.tableSearchText === "" ? (
            <Table
              {...this.state.tableState}
              bordered
              dataSource={filteredData}
              rowKey="userID"
              columns={addUserAgency}
              className={`${tableCSS} "ant-table-thead"`}
              scroll={{ y: 250 }}
            />
          ) : (
            <Table
              {...this.state.tableState}
              //id="myTable"  //rutuja task-4524 table responsive issue
              bordered
              dataSource={filteredData}
              rowKey="userID"
              columns={addUserAgency}
              // className="ant-table-thead table-responsive"
              //Nilesh-2897-Removing console warnings
              className={`${tableCSS} "ant-table-thead table-responsive"`}
            />
          )}
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "20px",
            marginTop: "20px",
            marginRight: "20px",
          }}
        >
          {this.state.filterStatus === "deactivatedUsers" ? (
            <button
              className="btn add-button buttonSave"
              type="submit"
              disabled={this.state.deactivatedUsersCheckboxArray.length === 0}
              onClick={() => this.changeUserStatusActive()}
              style={{
                width: "120px",
                borderRadius: "10px",
                boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
              }}
            >
              Activate
            </button>
          ) : (
            <button
              className="btn add-button buttonSave"
              type="submit"
              disabled={this.state.activatedUsersCheckboxArray.length === 0}
              onClick={() => this.changeUserStatusInactive()}
              style={{
                width: "120px",
                borderRadius: "10px",
                boxShadow: "rgba(71, 71, 71, 0.3) 0px 4px 6px 0px",
              }}
            >
              Deactivate
            </button>
          )}
        </div>

        <br />

        <Footer />
      </div>
    );
           } // end of render
         } // end of class

/**
 * @author Narendra Phadke
 * @param  Description handle the login authentication
 * @return Description return All details of authentication
 */
AddUserDIQA.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(
  withRouter(AddUserDIQA)
);
